var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"floatAlert"}},[(_vm.login && _vm.userNotificationsCount.smsCount)?_c('span',[_c('AdvertisementBanner',{attrs:{"activator":_vm.notsDialogSMS,"ad":{
        dispatch: {
          advertisement: {
            title: _vm.userNotificationsCount.smsCount,
          },
        },
      },"type":"smsLeft"},on:{"closeDial":function($event){return _vm.closeNotsCount()}}})],1):_vm._e(),(_vm.login && _vm.userNotificationsCount.whatsappCount)?_c('span',[_c('AdvertisementBanner',{attrs:{"activator":_vm.notsDialogWhatsapp,"ad":{
        dispatch: {
          advertisement: {
            title: _vm.userNotificationsCount.whatsappCount,
          },
        },
      },"type":"whatsappLeft"},on:{"closeDial":function($event){return _vm.closeNotsCount()}}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }